import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// core components
import Navbar from "./layouts/Navbar.js";
import Footer from "./layouts/Footer.js";

import '../assets/css/Board.css'

export default function Contact() {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  axios.defaults.withCredentials = true;

  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // mail form Values
    const fields = ["inputname", "inputemail", "inputphone", "inputsubject", "inputmessage"];
    const formElements = e.target.elements;

    const formValues = fields
    .map((field) => ({
      [field]: formElements.namedItem(field).value
    }))
    .reduce((current, next) => ({ ...current, ...next }));

    axios.post('/contact/mail',
      { ...formValues },
      { baseURL : process.env.REACT_APP_SERVER_URL },
      { withCredentials: true },
      { 
        headers : {
          'Content-Type': 'application/x-www-form-urlencoded', // HTML 폼 전송 방식
        }
      })
      .then((response) => {
        setIsLoading(false);
        if(response.data.status === 'Success'){
          alert(response.data.message);
          window.location.replace("/")
        } else {
          alert(t('ContactPage.Alert.SendFail'));
        }
      })
  }

  return (
    <>
    <Navbar />
    <div id="Contact" className="register-page">
      <div className="Section">
      {isLoading ? (
            // 로딩 중일 때 로딩 스피너 또는 메시지 표시
            <div className="loader" style={{height:'50%'}}>
              <div className="loader-container" style={{marginTop:'-30px'}}>
                <p className='loader-title'>Loading...</p>
              </div>
            </div>
          ) : (<></>)}
        <div className="cardWithTitle">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">{t('ContactPage.Header.Category')}</div>
              <div className="SectionHeaderTitle">{t('ContactPage.Header.Title')}</div>
              <div className="SectionHeaderDescription">
                {t('ContactPage.Header.Description1')}<br/>
                {t('ContactPage.Header.Description2')}
              </div>
            </div>
          </div>
          
          <div className="SectionContents" style={{marginTop:'30px'}}>
          
            <div className="form-control">
              <form onSubmit={ submitHandler }>
                <div className="form-box">
                  <label htmlFor="name">
                    <div className="form-label">{t('ContactPage.Form.NameLabel')}<b style={{color:'red'}}>&nbsp;*</b></div>
                    <input 
                      className="form-input"
                      type="text" 
                      id="name" 
                      name="inputname" 
                      placeholder={t('ContactPage.Form.NamePlaceholder')} 
                      required/>
                  </label>
                </div>
                <div className="form-box">
                  <label htmlFor="email">
                    <div className="form-label">{t('ContactPage.Form.EmailLabel')}<b style={{color:'red'}}>&nbsp;*</b></div>
                    <input 
                      className="form-input"
                      type="email" 
                      id="email" 
                      placeholder={t('ContactPage.Form.EmailPlaceholder')} 
                      name="inputemail" 
                      required/>
                  </label>
                </div>
                <div className="form-box">
                  <label htmlFor="phone">
                    <div className="form-label">{t('ContactPage.Form.PhoneLabel')}</div>
                    <input 
                      className="form-input"
                      type="text" 
                      id="phone" 
                      placeholder={t('ContactPage.Form.PhonePlaceholder')} 
                      name="inputphone" 
                      />
                  </label>
                </div>
                <div className="form-box">
                  <label htmlFor="subject">
                    <div className="form-label">{t('ContactPage.Form.SubjectLabel')}<b style={{color:'red'}}>&nbsp;*</b></div>
                    <input 
                      className="form-input"
                      type="text" 
                      id="subject" 
                      placeholder={t('ContactPage.Form.SubjectPlaceholder')} 
                      name="inputsubject" 
                      required/>
                  </label>
                </div>
                <div className="form-box">
                  <label htmlFor="message">
                    <div className="form-label">{t('ContactPage.Form.MessageLabel')}<b style={{color:'red'}}>&nbsp;*</b></div>
                    <textarea 
                      className="form-input-area"
                      id="message"
                      placeholder={t('ContactPage.Form.MessagePlaceholder')} 
                      name="inputmessage" 
                      required/>
                  </label>
                </div>
                <div className="form-button">
                  <input type="submit" value={t('ContactPage.Form.Submit')} />
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
    <Footer />
    </>
  );
}